const ewbRoleConstants = {
  NONE: "NONE",
  RE: "RE",
  RE_AUTHORITY: "RE AUTHORITY",
  EWB_REVIEW: "EWB REVIEW",
  EWB_ENTRY: "EWB ENTRY",
  DIST_DATA_ENTRY: "DISTRICT DATA ENTRY",
  STAFF: "STAFF (CALTRANS)"
};

export default ewbRoleConstants;
